module.exports = __webpack_public_path__ + "images/products/device-serial-image_no-logo-68e57536.svg";